import React from 'react';
import ClearModal from '../../../ClearModal/ClearModal';

interface ConfirmModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  actionType: 'delete' | 'reopen' | 'deleteClosed';
}

const MODAL_CONFIGS = {
  delete: {
    title: 'Delete Active Loaner',
    bodyText: 'Are you sure you want to delete this active loaner record?'
  },
  reopen: {
    title: 'Reopen Loaner',
    bodyText: 'Are you sure you want to reopen this closed loaner record?'
  },
  deleteClosed: {
    title: 'Delete Closed Loaner',
    bodyText: 'Are you sure you want to permanently delete this closed loaner record?'
  }
};

const ConfirmModal: React.FC<ConfirmModalProps> = ({
  open,
  onClose,
  onConfirm,
  actionType
}) => {
  // if no action type, don't render
  if (!actionType) {
    if (open) onClose();

    return null;
  }

  const { title, bodyText } = MODAL_CONFIGS[actionType];

  return (
    <ClearModal
      open={open}
      onClose={onClose}
      onConfirm={onConfirm}
      title={title}
      bodyText={bodyText}
    />
  );
};

export default ConfirmModal;